import CaptchaWidget from './captcha-widget'
export default CaptchaWidget
